<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="domainData" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="platfromcode" label="平台编码" prop="platfromcode">
                    <!--                     <a-input v-model="domainData.platfromcode" v-if="!is_vue_edit" @blur="
                        () => {
                            $refs.platfromcode.onFieldBlur();
                        }
                        "/>
                    <span class="form_span" v-else>{{ domainData.platfromcode }}</span> -->
                    <span class="form_span">{{ domainData.platfromcode }}</span>
                </a-form-model-item>
                <a-form-model-item ref="platfromname" label="平台名称" prop="platfromname">
                    <!--                     <a-input v-model="domainData.platfromname" @blur="
                        () => {
                            $refs.platfromname.onFieldBlur();
                        }
                        "/> -->
                    <span class="form_span">{{ domainData.platfromname }}</span>
                </a-form-model-item>

                <a-form-model-item ref="islog" label="是否需要登录日志" prop="islog">
                    <a-radio-group v-model="domainData.islog" button-style="solid" style="margin-left:15px">
                        <a-radio-button value="1"> 是</a-radio-button>
                        <a-radio-button value="0"> 否</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="defaultrolecode" label="默认角色" prop="defaultrolecode" v-if="is_vue_edit">
                    <a-select v-model="domainData.defaultrolecode" show-search placeholder="请选择">
                        <a-select-option v-for="(item) in syslist" :key="item.rolecode" v-model="item.rolecode">
                            {{ item.rolename + '【' + item.rolecode + '】' }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>

                <a-form-model-item label="备注" ref="remark" prop="remark" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                    <a-input v-model="domainData.remark" type="textarea" @blur="() => {
                                $refs.remark.onFieldBlur();
                            }
                            " />
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    addPlatFrom: '新增平台',
    editPlatFrom: '编辑平台',
}
export default {
    data() {
        return {
            m_title,
            c_title: '',
            labelCol: { span: 6 },
            wrapperCol: { span: 8 },
            rules: {
                platfromcode: [
                    {
                        required: true,
                        message: '请输入平台编码',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 50,
                        message: '请输入1~20个字符',
                        trigger: 'blur',
                    },
                ],
                platfromname: [
                    {
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 50,
                        message: '请输入1~20个字符',
                        trigger: 'blur',
                    },
                ],
                remark: [
                    {
                        min: 1,
                        max: 500,
                        message: '请输入1~500个字符',
                        trigger: 'blur',
                    },
                ],
            },
            confirmLoading: false,
            formItemLayout: 'horizontal',
            domainData: {},
            selecterState: {
                isShow: false,
                rowsType: 'radio', // or 'checkbox'，单选或多选
            },
            is_vue_edit: true,
            syslist: [],
        }
    },
    components: {},

    methods: {
        getSearchRoleConfig(platfromcode) {
            let c_params = {
                platfromcode: platfromcode,
                urlparams: false,
            }
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'ums/searchRoleConfig',
                    params: c_params,
                })
                .then((res) => {
                    console.log(res)
                    this.syslist = res.data.data
                })
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true
                    console.log(this.domainData)
                    const { params } = this.$route
                    if (
                        this.domainData.id &&
                        params.action != 'copydomainurl'
                    ) {
                        //编辑
                        this.$store
                            .dispatch({
                                type: 'ums/editPlatFromConfig',
                                params: this.domainData,
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    console.log(response)
                                    this.handleCancel()
                                    this.confirmLoading = false
                                }
                            })
                    } else {
                        //新增
                        this.$store
                            .dispatch({
                                type: 'ums/insertPlatFromConfig',
                                params: this.domainData,
                            })
                            .then((response) => {
                                console.log(response)
                                if (response.data.success == '1') {
                                    this.handleCancel()
                                }
                                this.confirmLoading = false
                            })
                    }
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },

        handleCancel() {
            this.resetForm()
            this.$router.back(-1)
        },
        resetForm() {
            this.$refs.ruleForm.resetFields()
        },
    },
    mounted() {
        const { query, params } = this.$route
        this.c_title = m_title[params.action]
        this.is_vue_edit = params.action != 'addPlatFrom'
        let that = this
        if (params.action != 'addPlatFrom') {
            that.$store
                .dispatch({
                    type: 'ums/selectPlatFromConfig',
                    params: query,
                })
                .then((res) => {
                    console.log(res)
                    that.tLoading = false
                    that.domainData = res.data.data[0]
                    if (that.domainData.platfromcode != '') {
                        that.getSearchRoleConfig(that.domainData.platfromcode)
                    }
                })
        } else {
            this.domainData = {
                id: '',
                appcode: '',
                domain: '',
                remark: '',
            }
        }
    },
}
</script>

<style lang="less" scoped>
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
